'use client';

import type { JSX } from 'react';
import type { MagicNodeSpec, MagicNodeStyleConfig } from '.';

export type MagicRendererProps = {
	payload: Record<string, unknown>;
	style: MagicNodeStyleConfig;
	spec: MagicNodeSpec;
};

export type MagicRenderer = (props: MagicRendererProps) => JSX.Element;

const MAGIC_RENDERER_REGISTRY = new Map<string, MagicRenderer>();

export function registerMagicRenderer(id: string, renderer: MagicRenderer) {
	MAGIC_RENDERER_REGISTRY.set(id, renderer);
}

export function getMagicRenderer(id?: string | null): MagicRenderer | undefined {
	if (!id) return undefined;
	return MAGIC_RENDERER_REGISTRY.get(id);
}


